<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['billing-title']"
    :description="propsdata[0]['translation']['billing-description']"
/>

<div v-if="loading" class="loader" style="margin: 100px auto;">
  <br><br>
  <div>
    <ul>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
    </ul>
  </div><span>{{propsdata[0]['translation']['billing-loading']}}</span>
</div>


    <div v-if="!loading" class="sc-kEYyzF grKTOC">
       <div class="sc-kAdXeD jwoEpG" style="padding: 0px 0px 30px 0px!important">
          <div class="sc-bvTASY jPMoWD">
             <div class="sc-cFlXAS WflZx">
                <div style="position: relative;">

                <div>
                       <div class="card border-light shadow-soft" style="margin-bottom:20px;margin: 0 auto;padding: 10px;border-left: .0625rem solid rgba(243,247,250,.05); border-right: .0625rem solid rgba(243,247,250,.05); border-bottom: .0625rem solid rgba(243,247,250,.05); border-top: 0; border-radius: 0 0 .5rem .5rem;">
                          <div class="card-body p-4 p-lg-3">
                             <div class="col-12">
                               <!-- UPDATE CARD -->
                               <div v-if="(propsdata[0].paid === 'yes' || propsdata[0].canceled === 'yes' || propsdata[0].canceled_due_attempt2 === 'yes') && cards !== 'no card'">
                               <h4 style="margin-bottom: 1rem;">{{propsdata[0]['translation']['billing-payment-method']}}</h4>
                               <!-- <p v-if="cards[0].expiring_card === 'yes'" style="color:#ff0000;">Just a quick heads up: your card is set to expire in a month. Update it as soon as possible.</p>
                               <p v-if="cards[0].expired_card === 'yes'" style="color:#ff0000;">Your card expired. Update it today in order to keep your termify.io account active.</p> -->
                               <div class="row">
                               <div class="col-auto">
                               <img v-if="cards[0].brand.toLowerCase() === 'mastercard'" src="https://termify.io/assets/img/mastercard.jpg" style="width: 80px;">
                               <img v-else-if="cards[0].brand.toLowerCase() === 'visa'" src="https://termify.io/assets/img/visa.jpg" style="width: 80px;">
                               <img v-else-if="cards[0].brand.toLowerCase() === 'american express'" src="https://termify.io/assets/img/amex.jpg" style="width: 80px;">
                               <img v-else-if="cards[0].brand.toLowerCase() === 'discover'" src="https://termify.io/assets/img/discover.jpg" style="width: 80px;">
                               <img v-else src="https://termify.io/assets/img/cc_placeholder.png" style="width: 80px;">
                               </div>
                               <div class="col-auto">
                               <p style="margin-bottom: 0;"><strong>{{cards[0].brand}} **** {{cards[0].last4}}</strong></p>
                               <p style="margin-bottom: 0;">{{propsdata[0]['translation']['billing-expires']}} <strong>{{cards[0].expiration_date}}</strong></p>
                               </div>
                               </div>
                               <!-- <a class="btn btn-secondary mt-4 animate-up-2" href=""><i class="fas fa-pen"></i> Update Card</a> -->
                               <hr>
                               </div>
                              <!-- SHOW INVOICES -->
                              <div v-if="invoices !== null">
                                <div class="col-md-12 row m-0 p-0">
                                  <h4 style="margin-bottom: 1rem;" class="col-md-9 p-0">{{propsdata[0]['translation']['billing-invoices']}}</h4>
                                  <router-link class="btn btn-success animate-up-2 mb-3 col-md-3" to="/dashboard/edit-billing">{{propsdata[0]['translation']['biling-edit-billing-information']}} <i class="fas fa-arrow-right"></i></router-link>
                                </div>
                                <ul class="list-group">
                                  <li v-for="(invoice, num) in invoices" class="list-group-item border-bottom" style="border: 1px solid #e1e1e1!important;">
                                    <div class="row align-items-center">
                                      <div class="col">
                                        <h3 class="h6 mb-1">
                                          <a :href="'https://termify.io/invoice/'+invoice.unique_id" target="_blank">{{propsdata[0]['translation']['billing-invoice-number']}} #{{invoice.unique_id}}</a>
                                        </h3>
                                        <small class="text-gray-700">{{propsdata[0]['translation']['billing-billed']}} {{invoice.date}}</small>
                                      </div>
                                      <div class="col-auto">
                                        <a :href="'https://termify.io/invoice/'+invoice.unique_id" target="_blank" class="btn btn-primary animate-up-2"><i class="fas fa-download"></i> {{propsdata[0]['translation']['billing-download']}}</a>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                               </div>
                               <div v-else-if="propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes' && propsdata[0].canceled !== 'yes'">
                                 <h4 class="mb-0">{{propsdata[0]['translation']['billing-upgrade-to-edit']}}</h4>
                               </div>
                               <div v-if="propsdata[0].paid === 'yes' && propsdata[0].cancel_at_period_end !== 'yes' && propsdata[0].canceled !== 'yes'">
                                   <hr>
                                   <div v-if="!canceled">
                                     <h4>{{propsdata[0]['translation']['billing-cancel-subscription']}}</h4>
                                     <p>{{propsdata[0]['translation']['billing-cancel-description']}}</p>
                                     <p>{{propsdata[0]['translation']['billing-cancel-note']}}</p>
                                     <button v-if="!cancelling" data-toggle="modal" data-target="#modal-cancel" class="btn btn-danger animate-up-2">{{propsdata[0]['translation']['billing-cancel-subscription']}}</button>
                                     <button v-if="cancelling" class="btn btn-danger animate-up-2"><i class="fas fa-spinner"></i> {{propsdata[0]['translation']['billing-cancelling']}}</button>
                                     <p v-if="cancellation_error" class="mt-3" style="color:red;">{{propsdata[0]['translation']['billing-cancellation-failed']}} <a :href="propsdata[0]['translation']['link-contact']" target="_blank" style="color: red; text-decoration: underline;">{{propsdata[0]['translation']['billing-contact-page']}}</a>.</p>
                                   </div>
                                   <div v-else>
                                     <h4>{{propsdata[0]['translation']['billing-subscription-canceled']}}</h4>
                                     <p>{{propsdata[0]['translation']['billing-you-can-subscribe']}}</p>
                                     <a :href="'/choose-plan/'+propsdata[0].unique_id" class="btn btn-success animate-up-2">{{propsdata[0]['translation']['billing-subscribe-again']}}</a>
                                   </div>
                               </div>
                               <div v-else-if="(propsdata[0].paid === 'yes' && propsdata[0].cancel_at_period_end === 'yes') || propsdata[0].canceled === 'yes'">
                                 <hr>
                                 <h4>{{propsdata[0]['translation']['billing-subscription-canceled']}}</h4>
                                 <p>{{propsdata[0]['translation']['billing-you-can-subscribe']}}</p>
                                 <a :href="'/choose-plan/'+propsdata[0].unique_id" class="btn btn-success animate-up-2">{{propsdata[0]['translation']['billing-subscribe-again']}}</a>
                               </div>
                               </div>
                            </div>
                          </div>

                  </div>

             </div>
          </div>
       </div>
    </div>

    <!-- MODAL CANCEL -->
    <div class="modal fade" id="modal-cancel" tabindex="-1" role="dialog" aria-labelledby="modal-cancel" aria-hidden="true">
       <div class="modal-dialog modal-dialog-centered" role="document">
           <div class="modal-content">
               <div class="modal-header">
                   <h6 class="modal-title">{{propsdata[0]['translation']['billing-really-cancel']}}</h6>
                   <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                       <span aria-hidden="true">&times;</span>
                   </button>
               </div>
               <div class="modal-footer">
                   <button v-if="!cancelling" @click="cancelsubscription" type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-success">{{propsdata[0]['translation']['billing-yes-cancel']}}</button>
                   <button v-if="cancelling" class="btn btn-sm btn-success">{{propsdata[0]['translation']['billing-cancelling']}}...</button>
                   <button type="button" class="btn btn-link text-danger ml-auto" data-dismiss="modal">{{propsdata[0]['translation']['billing-close']}}</button>
               </div>
           </div>
       </div>
   </div>

 </div>

</div>

</template>

<style>
a {
  color: #515151;
}
@media (max-width:991px) {
  .card{
    width:100%!important;
  }
}
.card-body {
    flex: 1 1 auto;
    padding: 1.5rem;
}
/* .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
} */
.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
}
.form-group {
    position: relative;
}
.form-group {
    margin-bottom: 1rem;
}
.text-dark, .text-dark:hover {
    color: #0d1431 !important;
}
.form-label {
    font-weight: 400;
    font-size: 1rem;
    display: block;
}
.text-danger, .text-danger:hover {
    color: #FA5252 !important;
}
.input-group {
    border-radius: 0.5rem;
    transition: all 0.2s ease;
}
.mb-4, .my-4 {
    margin-bottom: 1.5rem !important;
}
.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
}
.input-group-prepend {
    margin-right: -2px;
}
.input-group-text {
    font-size: 0.875rem;
    transition: all 0.3s ease-in-out;
}
.fa, .fas {
    font-weight: 900;
}
.fa, .far, .fas {
    font-family: "Font Awesome 5 Free";
}
.input-group .form-control:not(:first-child) {
    border-left: 0;
    padding-left: 0;
}
.input-group > .form-control, .input-group > .form-control-plaintext, .input-group > .custom-select, .input-group > .custom-file {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0;
}
.input-group .form-control:not(:first-child) {
    border-left: 0;
    padding-left: 0;
}
.text-center {
    text-align: center !important;
}
.animate-up-2, .animate-right-2, .animate-down-2, .animate-left-2, .scale-up-2, .scale-down-2 {
    transition: all 0.2s ease;
}
button:not(:disabled), [type="button"]:not(:disabled), [type="reset"]:not(:disabled), [type="submit"]:not(:disabled) {
    cursor: pointer;
}
.mr-2, .mx-2 {
    margin-right: 0.5rem !important;
}
.nav-tabs .nav-link:hover {
    border: none;
}
.editandowebsite {
    background-color: #f9fafb;
    border-color: #1e90ff5e;
    outline: 0;
    box-shadow: inset 0 1px 2px rgb(46 54 80 / 8%), 0 0 0 0.2rem rgb(38 43 64 / 20%);
}
@media (max-width:786px) {
  .mobilenopadding{
    padding:0px!important;
  }
  .mobilesinfloat{
    float: none!important;
  }
}
</style>

  <script>
  import ClickOutside from 'vue-click-outside';

  export default {
    props:['propsdata'],
    data() {
      return {
        loading: true,
        billing: [],
        cards: [],
        invoices: [],
        cancelling: false,
        canceled: false,
        cancellation_error: false
      };
    },
    methods: {
      cargarcards(){
        //CARGAR CARDS
        axios.post('/dashboard/cargar-cards.php', {
          })
          .then(response => {
            this.cards = response.data;
            this.cargarinvoices();
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      cargarinvoices(){
        //CARGAR INVOICES
        axios.post('/dashboard/cargar-invoices.php', {
          })
          .then(response => {
            this.invoices = response.data;
            this.loading = false;
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      cancelsubscription(){
        this.cancellation_error = false;
        this.cancelling = true;
        axios.post('/user-cancel-subscription', {
          token: lukastoken
          })
          .then(response => {
            this.cancelling = false;
            this.canceled = true;
            this.propsdata[0].cancel_at_period_end = 'yes';
        })
          .catch((error) => {
            console.log(error);
            this.cancelling = false;
            this.cancellation_error = true;
          });
      }
    },
    mounted() {
      this.$emit('updateprops');
      this.cargarcards();
      this.cargarinvoices();
    },
    // do not forget this section
directives: {
  ClickOutside
}
  };
  </script>



// WEBPACK FOOTER //
// src/billing.vue